module.exports = __webpack_public_path__ + "media/images/icon-arrow-right-white-39cbdc546f3ec78a6376e960a1f3ecac.svg";